var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('Top'),_c('div',{staticClass:"center"},[_c('router-view'),_c('div',{staticClass:"footer"},[_c('Bottom')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }